import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserGoldHero(props: Props) {
  const { onActivate } = props
  const intl = useIntl()
  const firstName = useAppSelector(state => state.auth.account.givenName)

  const exclusiveInviteLabel = intl.formatMessage({
    id: 'EJdvgY754x',
    defaultMessage: 'EXCLUSIVE INVITE',
    description: 'Tier label for exclusive gold invite on loyalty user page',
  })

  const congratulationsHeading = intl.formatMessage({
    id: 'b1c1aQIp7X',
    defaultMessage: 'Congratulations, you’re part of an exclusive group fast tracked to Gold as a thank you for being one of our most loyal travellers.',
    description: 'Subheading congratulating user on gold tier fast track',
  })

  const activateMembershipCta = intl.formatMessage({
    id: 'ia50HnUe96',
    defaultMessage: 'Activate your free membership',
    description: 'CTA button to activate free loyalty membership on gold hero',
  })

  return <HeroSection>
    <LayoutContainer variant="medium" style={{ zIndex: 1 }}>
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <Group direction="horizontal" gap={12}>
          <LoyaltyProgramNameLogo width={104} />
          <LoyaltyTierLabel kind="primary" tier="gold">
            {exclusiveInviteLabel}
          </LoyaltyTierLabel>
        </Group>
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              {firstName && <FormattedMessage
                id="A8SbQW1Gzg"
                defaultMessage="<italic>{firstName}</italic>, you’ve unlocked{br}<tierColour>Gold status</tierColour>"
                description="Loyalty gold hero heading with user name showing they unlocked gold status"
                values={{
                  firstName,
                  italic: (chunks) => <i>{chunks}</i>,
                  br: <br />,
                  tierColour: (chunks) => <Colour value="tier-gold-light-contrast">{chunks}</Colour>,
                }}
              />}
              {!firstName && <FormattedMessage
                id="cAEE3Ju3/8"
                defaultMessage="You’ve unlocked{br}<tierColour>Gold status</tierColour>"
                description="Loyalty gold hero heading without user name showing they unlocked gold status"
                values={{
                  br: <br />,
                  tierColour: (chunks) => <Colour value="tier-gold-light-contrast">{chunks}</Colour>,
                }}
              />}
            </Heading>
            <Heading variant="heading4">
              {congratulationsHeading}
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
          >
            <TextButton kind="primary" onClick={onActivate}>
              {activateMembershipCta}
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserGoldHero
